module.exports = __webpack_public_path__ + "static/img/footer-bg.71b7047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-bg.png
// module id = a1TC
// module chunks = 1